import './mobile-menu.component.scss';
import {clearAllBodyScrollLocks, disableBodyScroll} from 'body-scroll-lock';

$('.header .hamburger').on('click', function () {
  $(this).toggleClass('is-active');
  $('.mobile-nav').toggleClass('is-active');
  $('header').toggleClass('mobile-nav--is-active');
  disableBodyScroll(document.querySelector('.mobile-nav'));

  if ($('.mobile-nav--is-active').length === 0) {
    clearAllBodyScrollLocks();
  }
});
/////////
$('.mobile-nav__location-btn').on('click', function () {
  if ($('.mobile-nav__location-btn').next('ul:visible').length) {
    $('.mobile-nav__location-btn').next('ul:visible').slideUp();
    $('.mobile-nav__location-btn').removeClass('opened')
  } else {
    $('.mobile-nav__location-btn').next('ul').slideDown();
    $('.mobile-nav__location-btn').addClass('opened')
  }
});
$('.header__location-btn').on('click', function () {
  if ($('.header__location-btn').next('ul:visible').length) {
    $('.header__location-btn').next('ul:visible').slideUp(300);
  } else {
    $('.header__location-btn').next('ul').slideDown(300);
  }
});
$(window).on('load', function () {
  $('.header__location-btn').next('ul').hide();
  $('.mobile-nav__location-btn').next('ul').hide();
})
$(window).on('load resize', function () {
  if (window.innerWidth < 1280) {
    $('.header__location-btn').next('ul').hide();
    $('header .header__location-selector ul').appendTo('.mobile-nav__list-item-location');

    $('header .header__navigation nav').appendTo('.mobile-nav__nav-wrapper');

    $('.header__action-btn').appendTo('.mobile-nav__nav-wrapper');
  } else {
    $('.mobile-nav').removeClass('is-active');
    $('.hamburger').removeClass('is-active');
    $('header').removeClass('mobile-nav--is-active');
    $('.mobile-nav__nav-wrapper nav').appendTo('.header__navigation');
    $('.header__action-btn').appendTo('.header__btn-area');
    $('.mobile-nav__location-btn').next('ul').hide();
    $('.mobile-nav__list-item-location ul').appendTo('.header__location-selector');
    clearAllBodyScrollLocks();
  }
});